import {createSvgIcon} from '../create-svg-icon';

export const KeyboardControlKeyIcon = createSvgIcon(
  <path d="m5 12 1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z" />
, 'KeyboardControlKeyOutlined');
